import { create } from "zustand";
import api from "../../services/api.js";

const useSupplierStore = create((set) => ({
  suppliers: [],
  loading: false,
  error: null,

  getAllSuppliers: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get("/suppliers");
      set({ suppliers: response.data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  addSupplier: (suplier) => {
    set((state) => ({
      suppliers: [...state.suppliers, suplier],
    }));
  },

  removeSupplier: (id) => {
    set((state) => ({
      suppliers: state.suppliers.filter((supplier) => supplier.id !== id),
    }));
  },

  updateSupplier: (id, data) => {
    set((state) => ({
      suppliers: state.suppliers.map((sup) =>
        sup.id === id ? { ...sup, ...data } : sup
      ),
    }));
  },
}));

export default useSupplierStore;
